import styled from 'styled-components';

export const StyledContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;
    padding: 16px 12px;
`;

export const StyledFields = styled.div.attrs({ className: 'fixed-row-layout' })`
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
`;
